
import { defineComponent, ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import router from '@/router';
import { ElMessage } from 'element-plus';
export default defineComponent({
  name: 'AdminHead',
  setup() {
    const store = useStore();
    const adminName = ref();
    onMounted(() => {
      adminName.value = store.state.userInfo.username;
    });
    const out = () => {
      store.commit('logout');
      router.push('/main');
      ElMessage('登出成功！');
    };
    return {
      adminName,
      out,
    };
  },
});
